import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { getPractitionerList, getPractitionerAuthorizedList, getSingleUser } from "../../api/Individual";
import { failed, success } from "../../common/Toastify";
import { webSocketEndpoint } from "../../../environment";
import { editQueueItem, getActiveQueue } from "../api/WaitingRoom";
import { Col, Row, Table } from "react-bootstrap";
import { InputLabel, Skeleton, TableCell, Tooltip } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  AddCircleOutline,
  InfoOutlined,
  VideocamOutlined,
  AddIcCall,
  DescriptionOutlined,
  History,
} from "@mui/icons-material";
import { Button } from "../../common/Button";
import CustomPagination from "../../common/components/Pagination/CustomPagination";
import { FullPageSpinner } from "../../common/Spinner/FullPageSpinner";
import AddNoteModal from "./AddNoteModal";
import ViewNotesModal from "./ViewNotesModal";
import AssignPractitionerModal from "./AssignPractitionerModal";
import PriorityHistoryModal from "./PriorityHistoryModal";
import EditReasonForCallModal from "./EditReasonForCallModal";
import SearchBar from "./SearchBar";
import { ViewEncounterModal } from "./ViewEncounterModal";
import MultiSelect from "../../common/textfield/MultiSelect";
import SelectFiled from "../../common/textfield/SelectFiled";
import SearchSelect from "../../common/textfield/SearchSelect";
import { getServiceLinesByOrgId } from "../../api/ServiceLine";
import { useFormik } from "formik";
import moment from "moment";
import { ViewDate } from "../../../utils/DateSupport";
import Audio from "../../../assets/images/Audio.svg";
import Video from "../../../assets/images/Video.svg";
import EditIcon from "../../../assets/images/editIcon.svg";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery";
import { getAccessToken } from "../../../utils/authStorage";
import { AUTH_TOKEN_REFRESHED_EVENT } from "../../../lib/axios";

function getQueueRecordServiceLineId(data) {
  return (
    data?.serviceLineId ||
    data?.serviceLine?.reference?.split("/")?.[1] ||
    null
  );
}

function Queue() {
  const practitionerId = useSelector(
    (state) => state?.auth?.user?.["custom:unique_id"]
  );
  const [myUserId, setMyUserId] = useState("");
  const practUserName = useSelector(
    (state) => state?.auth?.user?.name[0]?.text
  );
  const [isLoading, setIsLoading] = useState(false);
  const [fullScreenLoader, setFullScreenLoader] = useState(false);
  const [userScopeOfPractice, setUserScopeOfPractice] = useState("");
  const [initiateWebsocketConnection, setInitiateWebsocketConnection] =
    useState(false);
  const [accessTokenVersion, setAccessTokenVersion] = useState(0);
  const userOrganizationId = useSelector(
    (state) => state?.auth?.user?.["organizations"][0].id
  );
  const [queuePatients, setQueuePatients] = useState([]);
  const [page, setPage] = useState(0);
  const ROWS_PER_PAGE_OPTIONS = [25, 50, 75, 100];
  const DEFAULT_ROWS_PER_PAGE = 50;
  const rowsPerPageStorageKey = practitionerId
    ? `queue.rowsPerPage.${practitionerId}`
    : null;
  const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);
  const totalRows = queuePatients?.length;
  const [currentTime, setCurrentTime] = useState(new Date());
  const [addNoteModalShow, setAddNoteModalShow] = useState(false);
  const [viewNoteModalShow, setViewNoteModalShow] = useState(false);
  const [addNoteModalData, setAddNoteModalData] = useState(null);
  const [assignPractData, setAssignPractData] = useState(null);
  const [assignPractModalShow, setAssignPractModalShow] = useState(false);
  const [newRecordId, setNewRecordId] = useState(null);
  const [encounterModal, setEncounterModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [priorityHistoryModal, setPriorityHistoryModal] = useState(false);
  const [editReasonModalShow, setEditReasonModalShow] = useState(false);
  const [editReasonModalData, setEditReasonModalData] = useState(null);
  const [searchFilterData, setSearchFilterData] = useState([]);
  const [practitionersUnderOrg, setPractitionersUnderOrg] = useState([]);
  const [practitionerOptions, setPractitionerOptions] = useState([]);
  const [selectedPractitionerFilter, setSelectedPractitionerFilter] =
    useState(null);
  const [selectedStatus, setSelectedStatus] = useState({
    data: "arrived",
    value: "arrived",
    label: "Arrived",
  });
  const [orgData, setOrgdata] = useState({})
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState(null)
  const [availableServiceLines, setAvailableServiceLines] = useState([]);
  const serviceLineFilterRef = useRef("");
  const selectedPrioritiesRef = useRef([]);
  const [isCTIEnabled, setCTIEnabled] = useState(false)
  const [myUserData, setMyUserData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    if (!rowsPerPageStorageKey) return;
    try {
      const raw = localStorage.getItem(rowsPerPageStorageKey);
      const parsed = raw ? Number(raw) : NaN;
      if (ROWS_PER_PAGE_OPTIONS.includes(parsed)) {
        setRowsPerPage(parsed);
      } else {
        setRowsPerPage(DEFAULT_ROWS_PER_PAGE);
      }
    } catch (e) {
      setRowsPerPage(DEFAULT_ROWS_PER_PAGE);
    }
  }, [rowsPerPageStorageKey]);

  useEffect(() => {
    if (!rowsPerPageStorageKey) return;
    try {
      localStorage.setItem(rowsPerPageStorageKey, String(rowsPerPage));
    } catch (e) {
      // no-op (storage may be unavailable)
    }
  }, [rowsPerPageStorageKey, rowsPerPage]);

  useOrgQuery({
    onSuccess: (data) => {
      setOrgdata(data);
      setOrganizations(data?.map((org) => ({ label: org?.name, value: org?.id }))) 
      const myOrg = data?.find(
        (org) => org?.id === userOrganizationId
      );

      setCTIEnabled(myOrg?.ctiSettings?.enabled || false);
      //setCTIEnabled(data?.[0]?.ctiSettings?.enabled)
      if(userScopeOfPractice){
        fetchData(userScopeOfPractice);
      }
    },
    refetchOnWindowFocus: false,
  })

  useEffect(() => {
    const onTokenRefreshed = () => setAccessTokenVersion((v) => v + 1);
    window.addEventListener(AUTH_TOKEN_REFRESHED_EVENT, onTokenRefreshed);
    return () => window.removeEventListener(AUTH_TOKEN_REFRESHED_EVENT, onTokenRefreshed);
  }, []);
  
  useEffect(() => {
    const token = getAccessToken();
    if (initiateWebsocketConnection && token && userOrganizationId && userScopeOfPractice) {
      fetchData(userScopeOfPractice);
      let orgIdsList;
      if (selectedOrganization) {
        // If user explicitly selected an organization, send only that one (small enough for URL)
        orgIdsList = [selectedOrganization];
      } else {
        // Send null - backend will derive full list server-side from user's base orgId
        orgIdsList = null;
      }

      // Ensure scopeOfPractice is an array before stringifying (matching server expectation)
      const scopeOfPracticeArray = Array.isArray(userScopeOfPractice) ? userScopeOfPractice : [userScopeOfPractice];
      const encodedScopeOfPractice = encodeURIComponent(JSON.stringify(scopeOfPracticeArray));
      
      // Build WebSocket URL - only include orgIdsList if provided (for backward compatibility)
      // If null, backend will derive it server-side (same pattern as getQueue API)
      const orgIdsListParam = orgIdsList ? `&orgIdsList=${encodeURIComponent(JSON.stringify(orgIdsList))}` : '';
      const wsUrl = `wss://${webSocketEndpoint}?token=${token}&organizationId=${userOrganizationId}${orgIdsListParam}&scopeOfPractice=${encodedScopeOfPractice}`;
      const ws = new WebSocket(wsUrl);

      ws.onopen = () => {
        console.log("WebSocket connection opened successfully");
        //setLoading(false);
      };
      ws.onmessage = (event) => {
        const newRecord = JSON.parse(event.data);

        switch (newRecord.messageType) {
          case "INSERT":
            if (newRecord?.status === selectedStatus?.value) {
              const lineFilter = serviceLineFilterRef.current;
              if (
                lineFilter &&
                getQueueRecordServiceLineId(newRecord) !== lineFilter
              ) {
                break;
              }
              const selectedPriorities = selectedPrioritiesRef.current;
              if (
                selectedPriorities?.length > 0 &&
                !selectedPriorities.includes(newRecord.priority)
              ) {
                break;
              }
              setQueuePatients((prevTableData) => {
                // Check if record already exists to prevent duplicates
                const existingIndex = prevTableData.findIndex(
                  (item) => item?.id === newRecord?.id
                );
                
                // Only add if it doesn't already exist
                if (existingIndex === -1) {
                  const updatedTableData = [...prevTableData, newRecord];
                  sortByPriorityAndStartDate(updatedTableData);
                  setNewRecordId(newRecord.id);
                  setTimeout(() => {
                    setNewRecordId(null);
                  }, 500);

                  return updatedTableData;
                }
                
                // If it already exists, return the previous data unchanged
                return prevTableData;
              });
            }
            break;

          case "MODIFY":
            // If the modified record matches the current filter, update it
            if (newRecord?.status === selectedStatus?.value) {
              const lineFilter = serviceLineFilterRef.current;
              const matchesLine =
                !lineFilter ||
                getQueueRecordServiceLineId(newRecord) === lineFilter;
              const selectedPriorities = selectedPrioritiesRef.current;
              const matchesPriority =
                !selectedPriorities?.length ||
                selectedPriorities.includes(newRecord.priority);
              const matchesFilters = matchesLine && matchesPriority;
              setQueuePatients((prevTableData) => {
                const existingIndex = prevTableData.findIndex(
                  (item) => item?.id === newRecord?.id
                );
                if (!matchesFilters) {
                  if (existingIndex !== -1) {
                    const updatedTableData = [...prevTableData];
                    updatedTableData.splice(existingIndex, 1);
                    sortByPriorityAndStartDate(updatedTableData);
                    return updatedTableData;
                  }
                  return prevTableData;
                }
                if (existingIndex !== -1) {
                  const updatedTableData = [...prevTableData];
                  updatedTableData[existingIndex] = newRecord;
                  sortByPriorityAndStartDate(updatedTableData);
                  return updatedTableData;
                }
                return prevTableData;
              });
            } 
            // If the record no longer matches the filter, remove it
            else {
              setQueuePatients((prevTableData) => {
                const existingIndex = prevTableData.findIndex(
                  (item) => item?.id === newRecord?.id
                );

                if (existingIndex !== -1) {
                  const updatedTableData = [...prevTableData];
                  updatedTableData.splice(existingIndex, 1);
                  sortByPriorityAndStartDate(updatedTableData);
                  return updatedTableData;
                }
                return prevTableData;
              });
            }
            break;
          case "REMOVE":
            // Remove the record from the queue regardless of status
            setQueuePatients((prevTableData) => {
              const existingIndex = prevTableData.findIndex(
                (item) => item?.id === newRecord?.id
              );

              if (existingIndex !== -1) {
                const updatedTableData = [...prevTableData];
                updatedTableData.splice(existingIndex, 1);
                sortByPriorityAndStartDate(updatedTableData);
                return updatedTableData;
              }
              return prevTableData;
            });
            break;
          default:
            break;
        }
      };

      ws.onclose = (event) => {
        console.log("WebSocket connection closed:", event);
      };

      ws.onerror = (error) => {
        console.error("WebSocket encountered an error:", error);
      };

      return () => {
        if (ws) {
          ws.close();
        }
      };
    }
  }, [initiateWebsocketConnection, selectedStatus, selectedOrganization, accessTokenVersion, userOrganizationId, userScopeOfPractice]);

  useEffect(() => {
    getPractitionerAuthorizedList((selectedOrganization || userOrganizationId), null, null, true)
      .then((res) => {
        if (res.status === true) {
          setPractitionersUnderOrg(res?.result);
          setPractitionerOptions(res?.result?.map((practitioner) => ({
                value: practitioner.id,
                // label: capitalizeWords(practitioner.name?.[0]?.text),
                label: capitalizeWords(practitioner.name?.[0]?.text),
                data: practitioner,
              })).sort((a, b) =>  a.label.localeCompare(b.label) /*a.value.localeCompare(b.value)*/));
        }
      })
      .catch((res) => {
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
        );
      });
  }, [selectedOrganization]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userRes = await getSingleUser({ id: practitionerId, type: "Practitioner" });
        const scope = userRes?.data?.scopeOfPractice;
  
        if (!scope) return; 
  
        setMyUserData(userRes?.data);
        setUserScopeOfPractice(scope);
        setMyUserId(userRes?.data?.link?.[0]?.target?.reference?.split("/")?.[1]);
        setInitiateWebsocketConnection(true);
  
      } catch (err) {
        failed(
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err.message
        );
      }
    };
  
    fetchUserData();
  }, []);

  const sortByPriorityAndStartDate = (data) => {
    if (!Array.isArray(data)) return [];

    return data.sort((a, b) => {
      const priorityComparison = a.priority - b.priority;
      if (priorityComparison === 0) {
        return new Date(a?.period?.start || 0) - new Date(b?.period?.start || 0);
      }
      return priorityComparison;
    });
  }
  
  const fetchData = async (scope) => {
    if (!scope) return;
  
    setIsLoading(true);
    try {
      const encodedScopeOfPractice = encodeURIComponent(JSON.stringify(scope)); 
  
      const res = await getActiveQueue({
        scopeOfPractice: encodedScopeOfPractice,
        status: selectedStatus?.value,
        orgId: userOrganizationId,
        // Pass selectedOrgId when user explicitly selects an org from dropdown
        ...(selectedOrganization && { selectedOrgId: selectedOrganization })
      });
  
      let sortedData = sortByPriorityAndStartDate(res?.result || []);
  
      if (formik?.values?.selectedPriorityLevels.length !== 0) {
        const selectedPriorities = formik.values.selectedPriorityLevels;
        sortedData = sortedData.filter((data) =>
          selectedPriorities.includes(data.priority)
        );
      }
  
      if (formik?.values?.selectedPractitionerFilter) {
        const selectedPractitioner = formik.values.selectedPractitionerFilter;
        sortedData = sortedData.filter(
          (data) =>
            data?.practitionerHistory &&
            data?.practitionerHistory[data?.practitionerHistory.length - 1]?.actor?.reference?.split("/")[1] === selectedPractitioner?.data?.id
        );
      }

      if (formik?.values?.serviceLineId) {
        const sid = formik.values.serviceLineId;
        sortedData = sortedData.filter(
          (data) => getQueueRecordServiceLineId(data) === sid
        );
      }

      setQueuePatients(sortedData);
      setSearchFilterData(sortedData);
    } catch (err) {
      failed(
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err.message
      );
    } finally {
      setIsLoading(false);
    }
  };
  

  const calculateWaitTime = (arrivalTimestamp) => {
    const currentTime = new Date();
    const currentTimestamp = currentTime.getTime();
    const waitTimeInMinutes = Math.floor(
      (currentTimestamp - arrivalTimestamp) / (1000 * 60)
    );

    return `${waitTimeInMinutes}`;
  };
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // Update every minute
    return () => clearInterval(intervalId);
  }, []);

  const handleUpdatePriority = (data, newPriority) => {
    setFullScreenLoader(true);
    const currentPriorityHistory = data?.priorityHistory || [];
    let actorPriorityChange = {
      actor: {
        display: practUserName,
        reference: `Practitioner/${myUserId}`,
        type: "Practitioner",
      },
      oldPriority: data?.priority,
      newPriority: newPriority,
      updatedAt: Date.now(),
    };
    const updatedPriorityHistory = [
      ...currentPriorityHistory,
      actorPriorityChange,
    ];
    editQueueItem(
      {
        id: data?.id,
        priority: newPriority,
        priorityHistory: updatedPriorityHistory,
      },
      userOrganizationId
    )
      .then((res) => {
        success(
          `Priority updated for ${capitalizeWords(
            data?.subject?.display
          )} to ${newPriority}`
        );
      })
      .catch((res) => {
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
        );
      })
      .finally(() => setFullScreenLoader(false));
  };

  const handleAddNoteClick = (data) => {
    setAddNoteModalData(data);
    setAddNoteModalShow(true);
  };

  const handleViewNotesClick = (data) => {
    setAddNoteModalData(data);
    setViewNoteModalShow(true);
  };

  const handleViewEncounterClick = (data) => {
    setSelectedRecord(data);
    setEncounterModal(true);
  };

  const capitalizeWords = (str) => {
    return (str) ? str
      .toLowerCase()
      .replace(/(^|\s)\S/g, (firstLetter) => firstLetter.toUpperCase()) : "" ;
  };

  const handleAssignPractitionerClick = (data) => {
    setAssignPractData(data);
    setAssignPractModalShow(true);
  };

  const handlePriorityHistoryView = (data) => {
    setSelectedRecord(data);
    setPriorityHistoryModal(true);
  };

  const handlePatientView = (data) => {
    const baseUrl = window.location.origin;
    const patientIdView = data?.subject?.reference?.split("/")?.[1];
    const patientNameView = data?.subject?.display;
    const url = `${baseUrl}/app/patients-details?patientId=${patientIdView}`//&patientName=${patientNameView}`;
    window.open(url, "_blank");
  };

  const handleFilterData = (data, resetPage = false) => {
    setSearchFilterData(data);
    if (resetPage) {
      setPage(0);
    }
  };

  // Keep current page when the list grows/shrinks; only move if it is out of range
  useEffect(() => {
    const maxPage = Math.max(
      0,
      Math.ceil(searchFilterData.length / rowsPerPage) - 1
    );
    if (page > maxPage) {
      setPage(maxPage);
    }
  }, [searchFilterData.length, rowsPerPage, page]);

  const statusOptions = [
    { status: "arrived", value: "arrived" },
    { status: "in-progress-waitingroom", value: "in-progress-waitingroom" },
    { status: "in-progress-appointment", value: "in-progress-appointment"},
    { status: "parked", value: "parked" },
    { status: "follow-up", value: "follow-up" }
  ].map((option) => ({
    value: option.value,
    label: capitalizeWords(option.status),
    data: option.status,
  }));

  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    formik.setFieldValue('selectedPriorityLevels', []);
  };

  const priorityOptions = [
    [1, 2, 3, 4, 5, 6, 7, 8].map((option) => ({
      name: option,
      value: option,
      id: option,
    })),
  ];

  const formik = useFormik({
    initialValues: {
      selectedPriorityLevels: [],
      selectedPractitionerFilter: null,
      serviceLineId: "",
    },
  });

  const handleFiltersChange = (filterArray) => {
    fetchData(userScopeOfPractice);
    page !== 0 && setPage(0);
  };

  const handleOrgChange = (event) => {
    let value = event?.value;
    setSelectedOrganization(value);
    formik.setFieldValue("organization", value);
    formik.setFieldValue("practitionerId", "")
    formik.setFieldValue("serviceLineId", "");
    setPractitionersUnderOrg([]);
    setPractitionerOptions([]);
    setPage(0);
  };

  const serviceLineSelectOptions = availableServiceLines.map((sl) => ({
    label: sl.name,
    value: sl.id,
  }));

  const handleServiceLineChange = (selected) => {
    formik.setFieldValue("serviceLineId", selected?.value || "");
    setPage(0);
  };

  useEffect(() => {
    handleFiltersChange();
  }, [formik?.values?.selectedPriorityLevels, formik?.values?.selectedPractitionerFilter, formik?.values?.serviceLineId]);

  useEffect(() => {
    serviceLineFilterRef.current = formik.values.serviceLineId || "";
  }, [formik.values.serviceLineId]);

  useEffect(() => {
    selectedPrioritiesRef.current =
      formik.values.selectedPriorityLevels || [];
  }, [formik.values.selectedPriorityLevels]);

  useEffect(() => {
    const orgForServiceLines =
      organizations.length > 1 ? selectedOrganization : userOrganizationId;

    if (organizations.length > 1 && !selectedOrganization) {
      setAvailableServiceLines([]);
      formik.setFieldValue("serviceLineId", "");
      return;
    }

    if (!orgForServiceLines) {
      setAvailableServiceLines([]);
      return;
    }

    getServiceLinesByOrgId(orgForServiceLines)
      .then((res) => {
        if (res?.status === true && Array.isArray(res?.data)) {
          const formatted = res.data
            .map((item) => ({
              name: item?.name,
              id: item?.id,
              value: item?.id,
            }))
            .sort((a, b) => (a.name || "").localeCompare(b.name || ""));
          setAvailableServiceLines(formatted);
        } else {
          setAvailableServiceLines([]);
        }
      })
      .catch(() => {
        setAvailableServiceLines([]);
      });
  }, [selectedOrganization, organizations.length, userOrganizationId]);

  const handlePreviewEncounterClick = (data, from = "draft") => {
    const baseUrl = window.location.origin;
    const encounterId = data?.id;
    const patientId = data?.subject?.reference?.split("/")?.[1];
    const url = `${baseUrl}/app/encounter-report?encounterId=${encounterId}&from=${from}`;
    window.open(url, "_blank");
  };

  return (
    <>
      {fullScreenLoader && <FullPageSpinner loadingText="Loading..." />}
      <section className="common-listing">
      <div className="dashSearch">
        <Row>
          <Col>
          <InputLabel> {"Search Patient"} </InputLabel>
              <SearchBar
                list={queuePatients || []}
                filterData={handleFilterData}
                style={{ width: 280, boxSizing: "border-box" }}
              />
          </Col>
          <Col>
          <InputLabel
                id="mutiple-select-label" 
              >
                {"Status"}
              </InputLabel>

              <div >
                <Select
                  onChange={handleStatusChange}
                  isMulti={false}
                  name="status"
                  options={statusOptions}
                  className="search-select"
                  classNamePrefix="select"
                  value={selectedStatus}
                  isClearable={false}
                  isLoading={statusOptions?.length > 0 ? false : true}
                />
              </div>
          </Col>
          <Col>
            <MultiSelect
                key={`priority-select-${JSON.stringify(selectedStatus)}`}
                options={priorityOptions[0]}
                keyField={"selectedPriorityLevels"}
                formik={formik}
                label={"Filter by Priority Level"}
                nodata={"No Data Found"}
                required={false}
                hideRequired={true}
              />
          </Col>
          {organizations.length > 1 && (
            <Col >
              <InputLabel
                id="mutiple-select-label" 
              >
                Filter by Organization
              </InputLabel>

              <Select
                keyField={"organization"}
                label={"Select Organization"}
                selectLabel="Select"
                formik={formik}
                options={organizations}
                isLoading={organizations?.length <= 1}
                readOnly={organizations?.length <= 1}
                hideRequired={true}
                onChange={handleOrgChange}
                onBlur={formik.handleBlur}
                className="search-select"
                classNamePrefix="select"
                isClearable={true}
              />
            </Col>
          )}

          <Col>
            <SearchSelect
                label="Service Line"
                required={false}
                hideRequired
                options={serviceLineSelectOptions}
                value={
                  serviceLineSelectOptions.find(
                    (opt) => opt.value === formik.values.serviceLineId
                  ) || null
                }
                onChange={handleServiceLineChange}
                placeholder={
                  organizations.length > 1 && !selectedOrganization
                    ? "Select organization first"
                    : "Select Service Line"
                }
                isDisabled={organizations.length > 1 && !selectedOrganization}
                isClearable
                formik={formik}
                keyField="serviceLineId"
                labelStyle={{
                  color: "rgba(0, 0, 0, 0.6)",
                  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                  fontWeight: 400,
                  fontSize: "1rem",
                  lineHeight: "1.4375em", 
                  marginBottom: "0px",
                }}
              />
          </Col>
          <Col>
            <InputLabel
              id="mutiple-select-label" 
            >
              {"Filter by Practitioner"}
            </InputLabel>
            <div style={{ width: "300px" }}>
              <Select
                name="selectedPractitionerFilter"
                onChange={(option) => formik.setFieldValue("selectedPractitionerFilter", option)}
                onBlur={formik.handleBlur}
                isMulti={false}
                options={practitionerOptions}
                className="search-select"
                classNamePrefix="select"
                value={formik.values.selectedPractitionerFilter}
                isClearable={true}
                isLoading={practitionerOptions?.length > 0 ? false : true}
              />
            </div>
          </Col>
        </Row>
      </div> 
        <div className="table-wrap">
          <Table>
            <thead>
              <tr>
                <th>Category</th> {/* Changed from Priority Reason to Category - Encouter Enhancement */}
                <th>Priority</th>
                <th style={{ textAlign: "center" }}>Patient Name</th>
                <th style={{ textAlign: "center"}}>Organization</th>
                <th style={{ textAlign: "center" }}>Location</th>
                <th style={{ textAlign: "center" }}>Reason</th>
                {selectedStatus?.value !== "in-progress-appointment" ? (
                  <th style={{ textAlign: "center" }}>Wait Time</th>
                ) : (
                  <th style={{ textAlign: "center" }}>Arrival Time</th>
                )}
                <th style={{ textAlign: "center", minWidth: "56px" }}>
                  Notes
                </th>
                <th style={{ textAlign: "center" }}>Channel</th>
                <th style={{ textAlign: "center" }}>Practitioner</th>
                <th style={{ textAlign: "center" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]?.map((val) => (
                  <tr key={val}>
                    <td>
                      <Skeleton animation="wave" />
                    </td>
                    <td>
                      <Skeleton animation="wave" />
                    </td>
                    <td>
                      <Skeleton animation="wave" />
                    </td>
                    <td>
                      <Skeleton animation="wave" />
                    </td>
                    <td>
                      <Skeleton animation="wave" />
                    </td>
                    <td>
                      <Skeleton animation="wave" />
                    </td>
                    <td>
                      <Skeleton animation="wave" />
                    </td>
                    <td>
                      <Skeleton animation="wave" />
                    </td>
                    <td>
                      <Skeleton animation="wave" />
                    </td>
                    <td>
                      <Skeleton animation="wave" />
                    </td>
                    <td>
                      <Skeleton animation="wave" />
                    </td>
                  </tr>
                ))
              ) : searchFilterData?.length > 0 ? (
                searchFilterData
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((data) => {
                    const waitTime = calculateWaitTime(data?.createdAt);
                    data.orgName = organizations.find(org => org.value === data.orgId)?.label

                    return (
                      <tr key={data?.id}>
                        <td
                          style={{
                            textTransform: "capitalize",
                          }}
                        >
                          {data?.intakeQuestions?.intakePriorityReason
                            ? data?.intakeQuestions?.intakePriorityReason
                            : "-"}
                        </td>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {selectedStatus.value === "arrived" ||
                            selectedStatus.value === "parked" ||
                            selectedStatus.value === "follow-up" ? (
                              <Select
                                value={
                                  data?.priority !== null
                                    ? {
                                        label: data?.priority,
                                        value: data?.priority,
                                      }
                                    : data.priority
                                    ? {
                                        label: data.priority,
                                        value: data.priority,
                                      }
                                    : null
                                }
                                options={[1, 2, 3, 4, 5, 6, 7, 8].map((value) => ({
                                  label: value,
                                  value,
                                }))}
                                onChange={(selectedOption) => {
                                  handleUpdatePriority(
                                    data,
                                    selectedOption ? selectedOption.value : null
                                  );
                                }}
                              />
                            ) : (
                              data?.priority
                            )}
                            <Tooltip
                              title={"View Priority History"}
                              style={{ marginLeft: "5px" }}
                            >
                              <div>
                                <Link
                                  variant="primary"
                                  className="view-btn"
                                  onClick={() =>
                                    handlePriorityHistoryView(data)
                                  }
                                >
                                  <History style={{ color: "#005ba8" }} />
                                </Link>
                              </div>
                            </Tooltip>
                          </div>
                        </td>

                        <td
                          style={{
                            textAlign: "center",
                            textTransform: "capitalize",
                          }}
                        >
                          <span
                            style={{
                              color: "#005ba8",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => handlePatientView(data)}
                          >
                            {data?.subject?.display}
                          </span>
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {data.orgName}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {data?.patientLocation}
                        </td>
                        {/* <td style={{ textAlign: "center" }}>
                          {data?.intakeQuestions?.intakeReason || data?.intakeQuestions?.reason ? (
                            <Tooltip
                              title={<>{data?.intakeQuestions?.intakeReason || data?.intakeQuestions?.reason}</>}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Link variant="primary" className="view-btn">
                                  <InfoOutlined style={{ color: "#005ba8" }} />
                                </Link>
                              </div>
                            </Tooltip>
                          ) : (
                            " "
                          )}
                        </td> */}
                        <td style={{ wordBreak: "break-word", maxWidth: "200px", whiteSpace: "pre-wrap" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <span style={{ flex: 1, paddingLeft: "5px", margin: 0 }}>
                                {data?.intakeQuestions?.intakeReason || data?.intakeQuestions?.reason
                                  ? data?.intakeQuestions?.intakeReason || data?.intakeQuestions?.reason
                                  : "-"}
                              </span>
                              <Tooltip title="Edit reason for call">
                                <Link
                                  variant="primary"
                                  className="view-btn"
                                  onClick={() => {
                                    setEditReasonModalData(data);
                                    setEditReasonModalShow(true);
                                  }}
                                  style={{ flexShrink: 0 }}
                                >
                                  <img
                                      src={EditIcon}
                                      alt={"Update"}
                                 />
                                </Link>
                              </Tooltip>
                            </div>
                         </td>
                        {selectedStatus?.value !== "finished" && (
                          <td style={{ textAlign: "center" }}>{waitTime} m</td>
                        )}
                        {selectedStatus?.value === "finished" && (
                          <td style={{ textAlign: "center" }}>
                            {ViewDate(data?.createdAt)}
                          </td>
                        )}
                        <td style={{ textAlign: "center", verticalAlign: "middle", minWidth: "56px" }}>
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {data?.notes?.length > 0 ? (
                              <Tooltip
                                title={
                                  <>
                                    Note:{" "}
                                    {data.notes[data.notes.length - 1]?.note}
                                    <br />
                                    <br /> {/* Empty line */}
                                    Added by:{" "}
                                    {capitalizeWords(
                                      data.notes[data.notes.length - 1]?.actor
                                        ?.display
                                    )}
                                    <br />
                                    Timestamp:{" "}
                                    {moment(
                                      data.notes[data.notes.length - 1]?.updatedAt
                                    ).format("DD-MMM-YY HH:mm")}
                                  </>
                                }
                              >
                                <div
                                  className="action-wrap"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Link
                                    onClick={() => handleViewNotesClick(data)}
                                    style={{
                                      backgroundColor: "#fff",
                                      border: "1px solid #cee0ef",
                                      borderRadius: "50%",
                                      padding: "5px",
                                    }}
                                  >
                                    <DescriptionOutlined
                                      style={{
                                        color: "#005da8",
                                        width: "24px",
                                        height: "20px",
                                      }}
                                    />
                                  </Link>
                                </div>
                              </Tooltip>
                            ) : (
                              " "
                            )}
                          </div>
                        </td>
                        <td>
                          <div
                            className="action-wrap"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >{data?.intakeQuestions?.preferredChannel === 'phone' || data?.intakeQuestions?.preferredChannel === 'video/chat' ? (
                            <div className="action-wrap">
                                {data?.intakeQuestions?.preferredChannel === 'phone' ? (
                                    <img src={Audio} alt="Audio Channel" />
                                ) : (
                                    <img src={Video} alt="Video Channel" />
                                )}
                            </div>) : "-"
                            }
                          </div>
                        </td>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {data?.practitionerHistory && data?.practitionerHistory?.[
                              data?.practitionerHistory?.length - 1
                            ]?.actor?.display &&
                            data?.practitionerHistory?.[
                              data?.practitionerHistory?.length - 1
                            ]?.actor?.display !== "-" ? (
                              <div>
                                <span>
                                  {capitalizeWords(
                                    data?.practitionerHistory[
                                      data?.practitionerHistory.length - 1
                                    ]?.actor?.display
                                  )}
                                </span>
                              </div>
                            ) : (
                              <div>
                                <Button
                                  title="Assign Practitioner"
                                  onClick={() =>
                                    handleAssignPractitionerClick(data)
                                  }
                                >
                                  Assign
                                </Button>
                              </div>
                            )}
                            {data?.practitionerHistory?.length > 0 && (
                              <Tooltip
                                title={"View Assigned Practitioner History"}
                                style={{ marginLeft: "5px" }}
                              >
                                <div>
                                  <Link
                                    variant="primary"
                                    className="view-btn"
                                    onClick={() =>
                                      handleAssignPractitionerClick(data)
                                    }
                                  >
                                    <History style={{ color: "#005ba8" }} />
                                  </Link>
                                </div>
                              </Tooltip>
                            )}
                          </div>
                        </td>

                        <td>
                          <div
                            className="action-wrap"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {data?.status !== "finished" && (
                              <Button
                                title="View Details And Action Items"
                                onClick={() => handleViewEncounterClick(data)}
                              >
                                View
                              </Button>
                            )}
                            {data?.status === "finished" && (
                              <div
                                onClick={() =>
                                  handlePreviewEncounterClick(data, "final")
                                }
                              >
                                <Tooltip title="View Encounter Report">
                                  <Link to="" className="success-btn">
                                    <DescriptionOutlined
                                      style={{
                                        color: "white",
                                        fontSize: "large",
                                      }}
                                    />
                                  </Link>
                                </Tooltip>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
              ) : (
                <tr>
                  <TableCell colSpan={"8"} style={{ textAlign: "center" }}>
                    No Data Available
                  </TableCell>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        {searchFilterData?.length > 0 ? (
          <CustomPagination
            tableData={searchFilterData}
            totalRows={searchFilterData?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            handlePage={(pageNo) => setPage(pageNo)}
            rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
            onRowsPerPageChange={(next) => {
              setRowsPerPage(next);
              setPage(0);
            }}
          />
        ) : null}
      </section>
      {addNoteModalShow && (
        <AddNoteModal
          data={addNoteModalData}
          onShow={addNoteModalShow}
          onHide={() => {
            setAddNoteModalShow(false)
            if (selectedStatus?.value === "follow-up" || selectedStatus?.value === "parked") {
              fetchData(userScopeOfPractice);
            }
          }}
        />
      )}

      {viewNoteModalShow && (
        <ViewNotesModal
          recordData={addNoteModalData}
          onShow={viewNoteModalShow}
          onHide={() => {
            setViewNoteModalShow(false)
            if (selectedStatus?.value === "follow-up" || selectedStatus?.value === "parked") {
              fetchData(userScopeOfPractice);
            }
            
          }}
        />
      )}
      {assignPractModalShow && (
        <AssignPractitionerModal
          data={assignPractData}
          onShow={assignPractModalShow}
          onHide={() => {
            setAssignPractModalShow(false)
            if (selectedStatus?.value === "follow-up" || selectedStatus?.value === "parked") {
              fetchData(userScopeOfPractice);
            }
          }}
        />
      )}
      {priorityHistoryModal && (
        <PriorityHistoryModal
          data={selectedRecord}
          onShow={priorityHistoryModal}
          onHide={() => {
            setPriorityHistoryModal(false)
            if (selectedStatus?.value === "follow-up" || selectedStatus?.value === "parked") {
              fetchData(userScopeOfPractice);
            }
          }}
        />
      )}
      {encounterModal && (
        <ViewEncounterModal
          data={searchFilterData.filter(res => res.id ===selectedRecord.id)[0]  || selectedRecord}
          onShow={encounterModal}
          isCTIEnabled={isCTIEnabled}
          organizations={organizations}
          onHide={() => {
            setEncounterModal(false)
            if (selectedStatus?.value === "follow-up" || selectedStatus?.value === "parked") {
              fetchData(userScopeOfPractice);
            }
          }}
        />
      )}
      {editReasonModalShow && editReasonModalData && (
        <EditReasonForCallModal
          data={editReasonModalData}
          onShow={editReasonModalShow}
          onHide={() => {
            setEditReasonModalShow(false);
            setEditReasonModalData(null);
          }}
          onSuccess={() => {
            if (userScopeOfPractice) fetchData(userScopeOfPractice);
          }}
        />
      )}
    </>
  );
}

export default Queue;
